import { TotalPrice } from './atlas-request.model';
import { CurrencyType } from './enums/currency.enum';

export class AtlasRequestCommercialAccount {
  commercialAccountNumber: string;
  totalPrice: TotalPrice;
  orderId: string;
  airlineCode: string;
  documentNumber: string;
  airportCode: string;
  passengerName: string;

  constructor(
    commercialAccount: string,
    amount: number,
    currencyString: string,
    orderId: string,
    airlineCode: string,
    documentNumber: string,
    airportCode: string,
    passengerName: string
  ) {
    this.commercialAccountNumber = commercialAccount;
    this.orderId = orderId;
    this.airlineCode = airlineCode;
    this.documentNumber = documentNumber;
    this.airportCode = airportCode;
    this.passengerName = passengerName;

    const currencyType: CurrencyType = CurrencyType[currencyString as keyof typeof CurrencyType];
    this.totalPrice = { amount: amount, currency: currencyType };
  }
}
